<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.ADD_SOCIAL_LINK' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

          <!-- Link -->
          <div class="mb-3">
            <label class="form-label fw-medium">
              {{ 'MENU.DASHBOARD.Link' | translate }}
            </label>

            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.Link' | translate }}"
              [(ngModel)]="formData.link"
              name="link"
              required
            />

            <small class="text-danger" *ngIf="errors?.link">
              {{ errors.link[0] }}
            </small>
          </div>

        <!-- Platform -->
<div class="mb-4">
  <label class="form-label fw-medium">
    {{ 'MENU.DASHBOARD.Platform' | translate }}
  </label>

  <select
    class="form-control"
    [(ngModel)]="formData.platform"
    name="platform"
    required
  >
    <option value="" disabled selected>
      {{ 'MENU.DASHBOARD.Select_Platform' | translate }}
    </option>

    <option *ngFor="let p of platforms" [value]="p">
      {{ p | titlecase }}
    </option>
  </select>

  <small class="text-danger" *ngIf="errors?.platform">
    {{ errors.platform[0] }}
  </small>
</div>

          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>
</div>
